import React, { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";

import "./style.css";
import { CalenderIcon } from "components/Icons";
import useOnClickOutside from "hooks/useOutsideClick";
import { Input } from "components/ui/input";

function parseYearFromDob(dobStr) {
  if (!dobStr || typeof dobStr !== "string") return null;
  const slash = dobStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slash) return Number(slash[3]);
  const d = new Date(dobStr);
  if (!Number.isNaN(d.getTime())) return d.getFullYear();
  return null;
}

const DatePicker = ({ methods }) => {
  const { control, watch, setValue, getValues } = methods;
  const dob = watch("dob");
  const currentYear = new Date().getFullYear();
  const startYear = 1990;
  const endYear = currentYear;
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i
  );

  const initialYear =
    parseYearFromDob(getValues("dob")) ?? currentYear;
  const [yearVal, setYearVal] = useState(initialYear);
  const [showBox, setShowBox] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    const y = parseYearFromDob(dob);
    if (y != null) setYearVal(y);
  }, [dob]);

  const handleClose = (e) => {
    e?.stopPropagation?.();
    setShowBox(false);
  };

  useOnClickOutside(popoverRef, handleClose);

  const handleYearClick = (year, event) => {
    event.stopPropagation();
    setYearVal(year);
    setValue("dob", `01/01/${year}`, {
      shouldValidate: true,
      shouldDirty: true,
    });
    setShowBox(false);
  };

  return (
    <>
      <div
        onClick={(e) => {
          setShowBox(!showBox);
          e.stopPropagation();
        }}
        className="relative !w-[210px] sm:!w-[340px] h-[56px] rounded-[30px] cursor-pointer"
      >
        <Controller
          name="dob"
          control={control}
          render={({ field }) => (
            <Input
              readOnly
              label="Date of Birth"
              placeholder="Select birth year"
              {...field}
              value={field.value ?? ""}
              className="h-[60px] !w-[210px] sm:!w-[340px] rounded-[30px] outline-none relative !cursor-pointer"
            />
          )}
        />

        <CalenderIcon
          onClick={(event) => {
            setShowBox(!showBox);
            event.stopPropagation();
          }}
          className="!absolute !w-5 !h-5 !bg-[#fff] !top-[15px] !right-[22px] !text-transparent cursor-pointer"
        />
      </div>

      {showBox && (
        <div
          ref={popoverRef}
          className="top-[310px] sm:top-[290px] shadow-lg w-[90%] sm:w-[427px] h-[320px] absolute z-30 left-5 sm:left-10 bg-[#fff] border border-black rounded-[10px]"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="month_head py-[6px] rounded-tl-[10px] rounded-tr-[10px] flex justify-center bg-white border-b border-[#999] font-bold items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="py-[16px] text-[20px]">
              Birth year{yearVal != null ? ` — ${yearVal}` : ""}
            </p>
          </div>

          <div className="months_text border-t border-[#999] h-[220px] w-full overflow-y-scroll scrollbar">
            <div className="flex flex-col pb-4">
              {years
                .slice()
                .reverse()
                .map((y) => (
                  <p
                    key={y}
                    className={`bg-transparent cursor-pointer !text-center text-black mt-6 px-4 ${y === yearVal ? "!bg-[#DEE6F0] font-bold py-[12px] text-black" : ""
                      }`}
                    onClick={(e) => handleYearClick(y, e)}
                  >
                    {y}
                  </p>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DatePicker;
